<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragDisabled]="dragDisabled$ | async" #draggable>
  <div class="dialog-control flex-space-btw">
    <div *ngIf="dragDisabled$ | async; else showDrag"></div>
    <ng-template #showDrag>
      <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
    </ng-template>

    <button mat-icon-button [mat-dialog-close]="false" color="accent" class="close-button right">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container>
    <h1 mat-dialog-title>Notes</h1>
    <mat-dialog-content>
      <div class="flex-1 flex-column">
        <div
          class="loading-container flex-column flex-place-content-center"
          *ngIf="(isLoading$ | async) && (readDisabled$ | async) === false; else loadedBlock"
        >
          <mat-spinner class="center-content"></mat-spinner>
        </div>
        <ng-template #loadedBlock>
          <ng-container *ngIf="(isCreating$ | async) === false">
            <div
              *ngFor="let note of notes; trackBy: trackById; let i = index"
              class="note-container flex-row flex-space-btw flex-1"
            >
              <ng-container *ngIf="note.isBeingEdited; else displayNote">
                <assess-note-form
                  class="flex-1"
                  [entityClass]="data.entityClass"
                  [entityId]="data.entityId"
                  [noteContent]="note.content"
                  [noteId]="note.id"
                  [entityVersion]="note.entityVersion"
                  [author]="note.createdBy"
                  (noteSaved)="onNoteSaved()"
                  (cancel)="note.isBeingEdited = false"
                >
                </assess-note-form>
              </ng-container>
              <ng-template #displayNote>
                <div class="flex-column">
                  <p class="note">{{ note.content }}</p>
                  <div class="flex-row flex-place-content-start">
                    <span class="note-name">
                      <ng-container *ngIf="note.createdBy?.data?.firstName; else email">
                        {{ note.createdBy?.data?.firstName }} {{ note.createdBy?.data?.lastName }}
                      </ng-container>
                      <ng-template #email>{{ note.createdBy?.data?.email }}</ng-template>
                    </span>
                    <span class="note-date">{{ note.createdAt | formatDateUtc: defaultWith24HourTime }}</span>
                  </div>
                </div>
                <div class="flex-row flex-space-btw" *ngIf="data?.userId === note.createdBy.id">
                  <div class="button-list">
                    <ng-container *ngIf="!note.isConfirmingDelete; else confirmDelete">
                      <button mat-icon-button (click)="onEditNoteClick(note)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        color="warn"
                        (click)="note.isConfirmingDelete = true"
                        [attr.data-testid]="'delete-init-' + i"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </ng-container>
                    <ng-template #confirmDelete>
                      <button
                        class="delete-button"
                        mat-flat-button
                        (click)="onDeleteNoteClick(note)"
                        color="warn"
                        [attr.data-testid]="'delete-confirm-' + i"
                      >
                        Delete
                      </button>
                      <button
                        mat-flat-button
                        (click)="note.isConfirmingDelete = false"
                        [attr.data-testid]="'delete-cancel-' + i"
                      >
                        Keep
                      </button>
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>
          <div *ngIf="!notes?.length && (isCreating$ | async) === false" class="note-container">
            <p class="note">{{ emptyMessage }}</p>
          </div>
        </ng-template>
      </div>
    </mat-dialog-content>

    <assess-note-form
      *ngIf="isCreating$ | async"
      [entityClass]="data.entityClass"
      [entityId]="data.entityId"
      [noteContent]=""
      [noteId]=""
      (noteSaved)="onNoteSaved()"
      (cancel)="isCreating$$.next(false)"
    ></assess-note-form>
    <mat-dialog-actions class="flex-row flex-space-btw" *ngIf="(isCreating$ | async) === false">
      <button mat-flat-button [mat-dialog-close]="false" color="accent">Close</button>
      <button
        data-testid="button-done"
        *ngIf="(editDisabled$ | async) === false"
        mat-flat-button
        color="primary"
        (click)="isCreating$$.next(true)"
      >
        <mat-icon>add_new</mat-icon>Create New Note
      </button>
    </mat-dialog-actions>
  </ng-container>
</div>
